import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutPageComponent } from '../layout/pages/layout.page/layout.page.component';
import { LoadStoreComponent } from './pages/load-store/load-store.component';
import { ListCediComponent } from './pages/list-cedi/list-cedi.component';
import { Page404PageComponent } from '../layout/pages/page404.page/page404.page.component';
import { ContextResolverService } from '../shared/sharedServices/contextResolver.service';

const routes: Routes = [
  {
    path: '',
    component: LayoutPageComponent,
    resolve: {
      context: ContextResolverService,
    },
    children: [
      {
        path: 'list',
        component: ListCediComponent,
      },
      {
        path: 'load',
        component: LoadStoreComponent,
      },
      { path: '**', component: Page404PageComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CediStoreRoutingModule {}
